import { resolveMatChartColors } from "src/app/shared/helpers/mat-chart-colors.helper";
import { BILLING_OVERVIEW_CLAIM_TYPE_ORDER } from "./billing-service-overview.model";

const FALLBACK_CHART_COLORS = [
  "#2c52e0",
  "#10b981",
  "#f59e0b",
  "#ef4444",
  "#8b5cf6",
  "#ec4899",
  "#14b8a6",
] as const;

/** Theme chart colors keyed by claim-type `value` (provider claim-type cache / API). */
export function resolveBillingOverviewChartColors(
  orderedValues: readonly string[] = BILLING_OVERVIEW_CLAIM_TYPE_ORDER,
): Record<string, string> {
  const themeColors = resolveMatChartColors();

  return Object.fromEntries(
    orderedValues.map((value, index) => [
      value,
      themeColors[index] ?? FALLBACK_CHART_COLORS[index] ?? FALLBACK_CHART_COLORS[0],
    ]),
  );
}
